import { Observable, Subscriber } from 'rxjs';

import { Column, Form } from '@rs-bank/rs-layout';

import { WizardResultStepWithLayout } from '../../../../../shared/wizard-v2/wizard-types/wizard-three-steps/steps/wizard-steps/layout-steps/with-layout-result.wizard-step';
import { ReferencesWizardBaseComponent } from '../reference-wizard.base';

export class ReferenceResultStep extends WizardResultStepWithLayout<ReferencesWizardBaseComponent, void> {

	public override init(): Observable<void> {
		return this.onInit();
	}

	public override onInit(): Observable<void> {
		return new Observable((subscriber: Subscriber<void>) => {
			this.layoutForm = this.buildResultLayout();
			this.buildResultStep();

			subscriber.next();
			subscriber.complete();
		});
	}

	protected override buildResultLayout(): Form<Column, Column | undefined> {
		return new Form(undefined, new Column([]), undefined);
	}

	protected override buildResultStep(): void {
		this.stepInformation.resultDescription.next('Операция выполнена');
		this.stepInformation.gotoMainLink.next(false);
		this.goBackVisibleForStep = true;
	}


}